/* eslint-disable react/jsx-no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/self-closing-comp */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/jsx-no-useless-fragment */
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth, OAUTH_CONFIG } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import RegisterConfirm from './pages/Register/RegisterConfirm';

// Lazy load page components for better performance
const ClubSelection = React.lazy(() => import('./pages/ClubSelection/ClubSelection'));
const Dashboard = React.lazy(() => import('./pages/Dashboard/Dashboard'));
const LoginPage = React.lazy(() => import('./pages/Login'));
const ManagerRegistrationPage = React.lazy(() => import('./pages/Register').then(module => ({ default: module.ManagerRegistrationPage })));
const ClubRegistrationPage = React.lazy(() => import('./pages/Register/ClubRegistrationPage'));
const CoachRegistrationPage = React.lazy(() => import('./pages/Register/CoachRegistrationPage'));
const ConfirmRegistration = React.lazy(() => import('./pages/Register/ConfirmRegistration'));
const UserRegistrationPage = React.lazy(() => import('./pages/Register/UserRegistrationPage'));
const AdminRegistrationPage = React.lazy(() => import('./pages/Register/AdminRegistrationPage'));
const FlowIoPage = React.lazy(() => import('./pages/FlowIo/FlowIoPage'));
const GlobalRegister = React.lazy(() => import('./pages/Register/GlobalRegister'));
const LandingPage = React.lazy(() => import('./pages/Landing/LandingPage'));
const ContinueOnApp = React.lazy(() => import('./pages/ContinueOnApp/ContinueOnApp'));

// Loading component for Suspense fallback
const LoadingSpinner: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
    <span className="ml-3 text-gray-600">Loading...</span>
  </div>
);

// Protected route component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

// Main App component
const AppContent: React.FC = () => {
  const { isAuthenticated, user, logout, isLoading } = useAuth();
  const navigate = useNavigate();

  // Auto-logout if token is missing - MUST be called before any conditional returns
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('access_token');
      if (!token && isAuthenticated) {
        logout();
      }
    };

    // Check auth on component mount
    checkAuth();

    // Set up a storage event listener to handle login/logout from other tabs
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'access_token' && !e.newValue && isAuthenticated) {
        logout();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [isAuthenticated, logout]);

  // Initialize theme from localStorage so colors persist across refresh.
  // If no theme is stored yet, apply a sensible light default theme once.
  useEffect(() => {
    try {
      const stored = localStorage.getItem('clubpro-theme');

      // If no stored theme, set a default light theme and persist it
      if (!stored) {
        const defaultTheme = {
          bg: '#f9fafb', // light app background
          headerBg: '#ffffff', // white header
          footerBg: '#ffffff',
          primary: '#2563eb', // blue primary
          text: '#000000', // black text
          clubText: '#2563eb', // blue club name
          sidebarBg: '#ffffff', // white sidebar background
          sidebarText: '#111827', // dark text in sidebar
          sidebarIcon: '#2563eb', // blue sidebar icons
          sidebarActiveBg: '#e5e7eb', // light grey active menu background
          sidebarHeaderBg: '#ffffff', // white sidebar header
          sidebarHeaderText: '#111827', // dark header text
          sidebarAvatarBg: '#e5e7eb', // light grey avatar background
          sidebarActiveText: '#111827', // dark text for active item
        } as const;

        document.documentElement.style.setProperty('--app-bg', defaultTheme.bg);
        document.documentElement.style.setProperty('--app-header-bg', defaultTheme.headerBg);
        document.documentElement.style.setProperty('--app-footer-bg', defaultTheme.footerBg);
        document.documentElement.style.setProperty('--app-primary', defaultTheme.primary);
        document.documentElement.style.setProperty('--app-text', defaultTheme.text);
        document.documentElement.style.setProperty('--app-club-text', defaultTheme.clubText);
        document.documentElement.style.setProperty('--app-sidebar-bg', defaultTheme.sidebarBg);
        document.documentElement.style.setProperty('--app-sidebar-text', defaultTheme.sidebarText);
        document.documentElement.style.setProperty('--app-sidebar-icon', defaultTheme.sidebarIcon);
        document.documentElement.style.setProperty('--app-sidebar-active-bg', defaultTheme.sidebarActiveBg);
        document.documentElement.style.setProperty('--app-sidebar-header-bg', defaultTheme.sidebarHeaderBg);
        document.documentElement.style.setProperty('--app-sidebar-header-text', defaultTheme.sidebarHeaderText);
        document.documentElement.style.setProperty('--app-sidebar-avatar-bg', defaultTheme.sidebarAvatarBg);
        document.documentElement.style.setProperty('--app-sidebar-active-text', defaultTheme.sidebarActiveText);

        try {
          localStorage.setItem('clubpro-theme', JSON.stringify(defaultTheme));
        } catch {
          // storage may be unavailable; ignore and continue
        }

        return;
      }

      const parsed = JSON.parse(stored) as {
        bg?: string;
        headerBg?: string;
        footerBg?: string;
        primary?: string;
        text?: string;
        clubText?: string;
        sidebarBg?: string;
        sidebarText?: string;
        sidebarIcon?: string;
        sidebarActiveBg?: string;
        sidebarHeaderBg?: string;
        sidebarHeaderText?: string;
        sidebarAvatarBg?: string;
        sidebarActiveText?: string;
      };

      if (parsed.bg) {
        document.documentElement.style.setProperty('--app-bg', parsed.bg);
      }
      if (parsed.headerBg) {
        document.documentElement.style.setProperty('--app-header-bg', parsed.headerBg);
      }
      if (parsed.footerBg) {
        document.documentElement.style.setProperty('--app-footer-bg', parsed.footerBg);
      }
      if (parsed.primary) {
        document.documentElement.style.setProperty('--app-primary', parsed.primary);
      }
      if (parsed.text) {
        document.documentElement.style.setProperty('--app-text', parsed.text);
      }
      if (parsed.clubText) {
        document.documentElement.style.setProperty('--app-club-text', parsed.clubText);
      }
      if (parsed.sidebarBg) {
        document.documentElement.style.setProperty('--app-sidebar-bg', parsed.sidebarBg);
      }
      if (parsed.sidebarText) {
        document.documentElement.style.setProperty('--app-sidebar-text', parsed.sidebarText);
      }
      if (parsed.sidebarIcon) {
        document.documentElement.style.setProperty('--app-sidebar-icon', parsed.sidebarIcon);
      }
      if (parsed.sidebarActiveBg) {
        document.documentElement.style.setProperty('--app-sidebar-active-bg', parsed.sidebarActiveBg);
      }
      if (parsed.sidebarHeaderBg) {
        document.documentElement.style.setProperty('--app-sidebar-header-bg', parsed.sidebarHeaderBg);
      }
      if (parsed.sidebarHeaderText) {
        document.documentElement.style.setProperty('--app-sidebar-header-text', parsed.sidebarHeaderText);
      }
      if (parsed.sidebarAvatarBg) {
        document.documentElement.style.setProperty('--app-sidebar-avatar-bg', parsed.sidebarAvatarBg);
      }
      if (parsed.sidebarActiveText) {
        document.documentElement.style.setProperty('--app-sidebar-active-text', parsed.sidebarActiveText);
      }
    } catch {
      // ignore theme parse errors
    }
  }, []);

  // Show loading spinner while auth context is initializing
  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <GoogleOAuthProvider clientId={OAUTH_CONFIG.google.clientId}>
      <div className="App">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
          <Route
            path="/select-club"
            element={
              <ProtectedRoute>
                <ClubSelection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard user={user!} onLogout={logout} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              isAuthenticated
                ? <Navigate to={localStorage.getItem('clubId') ? '/dashboard' : '/select-club'} replace />
                : <LandingPage />
            }
          />
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to={localStorage.getItem('clubId') ? '/dashboard' : '/select-club'} replace /> : <LoginPage />}
          />
          <Route path="/confirm-registration" element={<ConfirmRegistration />} />
          <Route path="/club-register" element={<ClubRegistrationPage />} />
          <Route path="/coach-register" element={<CoachRegistrationPage />} />
          <Route path="/manager-register" element={<ManagerRegistrationPage />} />
          <Route path="/member-register" element={<UserRegistrationPage />} />
          <Route path="/admin-register" element={<AdminRegistrationPage />} />
          <Route path="/flow-io" element={<FlowIoPage />} />
          <Route path="/continue-on-app" element={<ContinueOnApp />} />
          <Route path="/register" element={<GlobalRegister />} />
          <Route path="/register-confirm" element={<RegisterConfirm />} />
          </Routes>
        </Suspense>
      </div>
    </GoogleOAuthProvider>
  );
};

// Main App wrapper with AuthProvider and LanguageProvider
const App: React.FC = () => {
  return (
    <Router>
      <LanguageProvider defaultLanguage="en">
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </LanguageProvider>
    </Router>
  );
};

export default App;
